/**
 * Shared CSS cursor values (white default / black hover).
 * Hotspots match the tip of each glyph in the 32×32 assets.
 */
export const CURSOR_ARROW = "url('/assets/cursors/arrow.svg') 5 6, default";
export const CURSOR_ARROW_HOVER = "url('/assets/cursors/arrow-hover.svg') 5 6, pointer";

export const CURSOR_FLAG = "url('/assets/cursors/flag.svg') 5 29, crosshair";
export const CURSOR_FLAG_HOVER = "url('/assets/cursors/flag-hover.svg') 5 29, pointer";

export const CURSOR_ERASER = "url('/assets/cursors/eraser.svg') 4 19, crosshair";
export const CURSOR_ERASER_HOVER = "url('/assets/cursors/eraser-hover.svg') 4 19, pointer";

const PLAY_ATTR = 'data-play-cursor';
const EDITOR_ATTR = 'data-editor-cursor';

/** Start screen + GameScene: custom white arrow; hover uses the black twin. */
export function setPlayCursor(enabled: boolean): void {
  const root = document.documentElement;

  if (enabled) {
    root.setAttribute(PLAY_ATTR, '');
    root.removeAttribute(EDITOR_ATTR);
  } else {
    root.removeAttribute(PLAY_ATTR);
  }
}

/**
 * Editor canvas/tool mode. `tool` is the active EditorTool id (or empty while
 * tearing down). Clears play-cursor mode so the two never stack.
 */
export function setEditorCursor(tool: string | null): void {
  const root = document.documentElement;

  if (tool == null) {
    root.removeAttribute(EDITOR_ATTR);
    return;
  }

  root.removeAttribute(PLAY_ATTR);
  root.setAttribute(EDITOR_ATTR, tool);
}
